import React from 'react'
import "../../Styles/Projects/Projects.css"
import ProjectCard from './ProjectCard';

function Projects({ projects, skills, handleRobotText }) {
  return (
    <section id="projects" className="projects">
      <div className="projectsContainer flexBox">
        <h1>Projects</h1>

        <div className="projectsBox flexBox">
          {projects.map((project) => (
            <ProjectCard
              key={project.title}
              {...project}
              skills={skills}
              handleRobotText={handleRobotText}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects
